import React, { useState } from 'react';

const s = {
  section: {
    padding: '100px 0',
    background: 'linear-gradient(180deg, #050815, #080d20)',
    position: 'relative',
  },
  glow: {
    position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)',
    width: 800, height: 400,
    background: 'radial-gradient(ellipse, rgba(108,99,255,0.08) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  container: { maxWidth: 1100, margin: '0 auto', padding: '0 24px', position: 'relative' },
  header: { textAlign: 'center', marginBottom: 60 },
  tag: {
    display: 'inline-flex', alignItems: 'center', gap: 6,
    background: 'rgba(108,99,255,0.1)', border: '1px solid rgba(108,99,255,0.25)',
    borderRadius: 100, padding: '5px 14px',
    fontSize: 11, fontFamily: 'Sora, sans-serif', fontWeight: 500,
    color: '#a5a0ff', marginBottom: 20,
  },
  h2: { fontFamily: 'Sora, sans-serif', fontSize: 40, fontWeight: 800, marginBottom: 14 },
  purple: {
    background: 'linear-gradient(135deg, #6c63ff, #818cf8)',
    WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', backgroundClip: 'text',
  },
  subtext: { color: '#8892b0', fontSize: 15, fontFamily: 'DM Sans, sans-serif', lineHeight: 1.7 },
  grid: { display: 'grid', gridTemplateColumns: '1fr 1.5fr', gap: 40, alignItems: 'start' },
  // Left info
  infoCards: { display: 'flex', flexDirection: 'column', gap: 14 },
  infoCard: {
    background: 'rgba(13,18,41,0.8)', border: '1px solid rgba(255,255,255,0.07)',
    borderRadius: 14, padding: '18px 20px',
    display: 'flex', alignItems: 'center', gap: 16,
  },
  infoIcon: {
    width: 40, height: 40, borderRadius: 10,
    background: 'rgba(108,99,255,0.15)', border: '1px solid rgba(108,99,255,0.3)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, flexShrink: 0,
  },
  infoLabel: { fontSize: 10, color: '#8892b0', fontFamily: 'DM Sans, sans-serif', textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 3 },
  infoValue: { fontSize: 14, color: '#f0f4ff', fontFamily: 'Sora, sans-serif', fontWeight: 500 },
  teamImg: {
    borderRadius: 14, overflow: 'hidden', marginTop: 14,
    background: 'linear-gradient(135deg, rgba(108,99,255,0.2), rgba(59,130,246,0.2))',
    height: 160, display: 'flex', alignItems: 'center', justifyContent: 'center',
    border: '1px solid rgba(255,255,255,0.07)', fontSize: 40,
  },
  whyList: { marginTop: 20 },
  whyTitle: { fontSize: 13, color: '#8892b0', fontFamily: 'Sora, sans-serif', fontWeight: 600, marginBottom: 12, textTransform: 'uppercase', letterSpacing: 0.8 },
  whyItem: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#c0c8e0', fontFamily: 'DM Sans, sans-serif', marginBottom: 8 },
  // Right form
  form: {
    background: 'rgba(13,18,41,0.8)', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 18, padding: 36,
  },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 },
  formGroup: { display: 'flex', flexDirection: 'column', gap: 6, marginBottom: 16 },
  label: { fontSize: 11, color: '#8892b0', fontFamily: 'Sora, sans-serif', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8 },
  required: { color: '#6c63ff' },
  input: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8, padding: '10px 14px', color: '#f0f4ff',
    fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none',
    transition: 'border-color 0.2s', width: '100%',
  },
  select: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8, padding: '10px 14px', color: '#8892b0',
    fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none',
    width: '100%', cursor: 'pointer',
  },
  textarea: {
    background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: 8, padding: '10px 14px', color: '#f0f4ff',
    fontSize: 14, fontFamily: 'DM Sans, sans-serif', outline: 'none',
    width: '100%', resize: 'vertical', minHeight: 100,
  },
  submitBtn: {
    width: '100%', padding: '14px', borderRadius: 10,
    background: 'linear-gradient(135deg, #6c63ff, #4f46e5)',
    border: 'none', color: '#fff',
    fontSize: 15, fontFamily: 'Sora, sans-serif', fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.2s',
    boxShadow: '0 8px 25px rgba(108,99,255,0.4)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
    marginBottom: 12,
  },
  formNote: { fontSize: 11, color: '#4a5568', fontFamily: 'DM Sans, sans-serif', textAlign: 'center' },
  link: { color: '#6c63ff', cursor: 'pointer' },
};

export default function Contact() {
  const [form, setForm] = useState({ nombre: '', empresa: '', correo: '', telefono: '', plan: '', mensaje: '' });
  const [sent, setSent] = useState(false);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const submit = (e) => {
    e.preventDefault();
    setSent(true);
  };

  return (
    <section style={s.section} id="contacto">
      <div style={s.glow} />
      <div style={s.container}>
        <div style={s.header}>
          <div style={s.tag}>✉️ Contáctanos</div>
          <h2 style={s.h2}>¿Listo para <span style={s.purple}>transformar tu empresa?</span></h2>
          <p style={s.subtext}>
            Nuestro equipo está listo para ayudarte. Escríbenos y te contactaremos en menos de 24 horas hábiles.
          </p>
        </div>

        <div style={s.grid}>
          {/* Left */}
          <div>
            <div style={s.infoCards}>
              {[
                { icon: '✉️', label: 'Correo Electrónico', value: 'contacto@archivex.mx' },
                { icon: '📞', label: 'Teléfono', value: '+52 (55) 1542-6829' },
                { icon: '📍', label: 'Oficina Principal', value: 'Ciudad de México, México' },
              ].map(item => (
                <div key={item.label} style={s.infoCard}>
                  <div style={s.infoIcon}>{item.icon}</div>
                  <div>
                    <div style={s.infoLabel}>{item.label}</div>
                    <div style={s.infoValue}>{item.value}</div>
                  </div>
                </div>
              ))}
            </div>

            <div style={s.teamImg}>
              <img 
                src="/assets/teams.png" 
                alt="Equipo ArchiVex" 
                style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
              />
            </div>

            <div style={s.whyList}>
              <div style={s.whyTitle}>¿Por qué elegirnos?</div>
              {[
                '14 días de prueba gratuita',
                'Sin tarjeta de crédito requerida',
                'Configuración en menos de 1 hora',
                'Soporte completo en español',
                'Datos almacenados en México',
              ].map(t => (
                <div key={t} style={s.whyItem}>
                  <span style={{ color: '#6c63ff' }}>✅</span> {t}
                </div>
              ))}
            </div>
          </div>

          {/* Right - Form */}
          <div style={s.form}>
            {sent ? (
              <div style={{ textAlign: 'center', padding: '40px 0' }}>
                <div style={{ fontSize: 60, marginBottom: 20 }}>🎉</div>
                <h3 style={{ fontFamily: 'Sora, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 12 }}>¡Mensaje enviado!</h3>
                <p style={{ color: '#8892b0', fontFamily: 'DM Sans, sans-serif' }}>Te contactaremos en menos de 24 horas hábiles.</p>
              </div>
            ) : (
              <form onSubmit={submit}>
                <div style={s.formGrid}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <label style={s.label}>Nombre Completo <span style={s.required}>*</span></label>
                    <input style={s.input} name="nombre" value={form.nombre} onChange={handle} placeholder="Juan García" required
                      onFocus={e => e.target.style.borderColor = 'rgba(108,99,255,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <label style={s.label}>Empresa <span style={s.required}>*</span></label>
                    <input style={s.input} name="empresa" value={form.empresa} onChange={handle} placeholder="Mi Empresa S.A. de C.V." required
                      onFocus={e => e.target.style.borderColor = 'rgba(108,99,255,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <label style={s.label}>Correo Corporativo <span style={s.required}>*</span></label>
                    <input style={s.input} name="correo" type="email" value={form.correo} onChange={handle} placeholder="juan@empresa.com.mx" required
                      onFocus={e => e.target.style.borderColor = 'rgba(108,99,255,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                    <label style={s.label}>Teléfono</label>
                    <input style={s.input} name="telefono" value={form.telefono} onChange={handle} placeholder="+52 55 1234 5678"
                      onFocus={e => e.target.style.borderColor = 'rgba(108,99,255,0.5)'}
                      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                    />
                  </div>
                </div>

                <div style={{ ...s.formGroup }}>
                  <label style={s.label}>Plan de Interés</label>
                  <select style={s.select} name="plan" value={form.plan} onChange={handle}>
                    <option value="">Selecciona un plan...</option>
                    <option value="basico">Básico - $29/mes</option>
                    <option value="profesional">Profesional - $89/mes</option>
                    <option value="empresarial">Empresarial - $249/mes</option>
                    <option value="personalizado">Solución Personalizada</option>
                  </select>
                </div>

                <div style={s.formGroup}>
                  <label style={s.label}>Mensaje <span style={s.required}>*</span></label>
                  <textarea style={s.textarea} name="mensaje" value={form.mensaje} onChange={handle}
                    placeholder="Cuéntanos sobre tu empresa y qué necesitas de ArchiVex..."
                    required
                    onFocus={e => e.target.style.borderColor = 'rgba(108,99,255,0.5)'}
                    onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
                  />
                </div>

                <button type="submit" style={s.submitBtn}
                  onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                  onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                >
                  📨 Enviar mensaje
                </button>
                <div style={s.formNote}>
                  Al enviar este formulario aceptas nuestra{' '}
                  <span style={s.link}>Política de Privacidad</span>{' '}y nuestros{' '}
                  <span style={s.link}>Términos de Uso</span>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
